<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="entertainers"
      :loading="loading"
      :itemsPerPage="itemsPerPage"
      item-key="ID"
      class="page__table"
      hide-default-footer
    >
      <template v-slot:top>
        <custom-table-title 
          :onAdd="handleAdd"
          :title="`Animadores`"
          icon="mdi-ticket"
          :onSearch="handleSearch"
        />
      </template>
      <template v-slot:[`item.ident`]="{ item }">
        <a @click="() => { handleEdit(item) }">{{ item.Name || item.ID }}</a>
      </template>
      <!--template v-slot:[`item.category`]="{ item }">
        {{ plan.category ? plan.category.filter(x => x.id === item.CategoryID).map(item => item.name.es).shift() : '' }}
      </template>
      <template v-slot:[`item.subcategory`]="{ item }">
        {{ plan.subcategory ? plan.subcategory.filter(x => x.id === item.SubcategoryID).map(item => item.name.es).shift() : '' }}
      </template>
      <template v-slot:[`item.weekday`]="{ item }">
        {{ plan.weekday ? plan.weekday.filter(x => x.id === item.WeekdayID).map(item => item.name.es).shift() : '' }}
      </template-->
      <!--template v-slot:body="props">

      </template-->
    </v-data-table>
    <pagination
      :startIndex="startIndex"
      :itemsPerPage="itemsPerPage"
      :count="count"
      :onGetData="handleGetData"
      :locale="locale"
    />
  </div>
</template>
<script>
const defaultItem = {
  Name: null,
  Description: { es: '' },
}
import api from '@/services/api'
import utilsService from '@/services/utils'
import CustomTableTitle from '@/components/customTable/CustomTableTitle'
import Pagination from '@/components/customTable/Pagination'
export default {
  components: {
    CustomTableTitle,
    Pagination,
  },
  props: {
    locale: {
      type: String,
      required: true,
    },
    onEdit: {
      type: Function,
      requried: true,
    },
    forceRefresh: {
      type: String,
      default: null,
    },
    contentTypeID: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    search: '',
    startIndex: 0,
    itemsPerPage: 1000,
    entertainers: [],
    count: null,
  }),
  computed: {
    headers () {
      return [
        { text: 'Nombre', value: 'ident',  sortable: false, align: 'left', },
      ]
    },
  },
  watch: {
    forceRefresh () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    getTranslation (v, locale) {
      return utilsService.getTranslation(v, locale)
    },
    handleSearch (v) {
      this.search = v
      this.handleGetData(0)
    },
    handleGetData (startIndex) {
      if (startIndex >= 0 ) this.startIndex = startIndex
      const url = `v1/private/activity-barcelo-01/${this.contentTypeID}/entertainers/`
      api.getAll ('dviewcontent', url, this.startIndex, this.itemsPerPage, this.search)
        .then(response => {
          if (!response) {
            this.loading = false
            return
          }
          this.entertainers = response.map(item => {
            item.Description = item.Description ? JSON.parse(item.Description) : { es: '' }
            return item
          })
          this.count = this.entertainers.length
          this.loading = false
        })
    },
    handleAdd () {
      const aux = defaultItem
      aux.ContentTypeID = this.contentTypeID
      this.onEdit(aux)
    },
    handleEdit (v) {
      this.onEdit(v)
    },
  },
}
</script>

